/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Offline_Status_AuthenticationInputs */

const en_offline_status_authentication = /** @type {(inputs: Offline_Status_AuthenticationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Authentication`)
};

const fr_offline_status_authentication = /** @type {(inputs: Offline_Status_AuthenticationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Authentification`)
};

const de_offline_status_authentication = /** @type {(inputs: Offline_Status_AuthenticationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Authentifizierung`)
};

const it_offline_status_authentication = /** @type {(inputs: Offline_Status_AuthenticationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Autenticazione`)
};

const ru_offline_status_authentication = /** @type {(inputs: Offline_Status_AuthenticationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Аутентификация`)
};

const es_offline_status_authentication = /** @type {(inputs: Offline_Status_AuthenticationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Autenticación`)
};

const zh_cn2_offline_status_authentication = /** @type {(inputs: Offline_Status_AuthenticationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`验证`)
};

const ja_offline_status_authentication = /** @type {(inputs: Offline_Status_AuthenticationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`認証`)
};

const hi_offline_status_authentication = /** @type {(inputs: Offline_Status_AuthenticationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`प्रमाणीकरण`)
};

const pt_pt2_offline_status_authentication = /** @type {(inputs: Offline_Status_AuthenticationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Autenticação`)
};

/**
* | output |
* | --- |
* | "Authentication" |
*
* @param {Offline_Status_AuthenticationInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const offline_status_authentication = /** @type {((inputs?: Offline_Status_AuthenticationInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Offline_Status_AuthenticationInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_offline_status_authentication(inputs)
	if (locale === "de") return de_offline_status_authentication(inputs)
	if (locale === "it") return it_offline_status_authentication(inputs)
	if (locale === "ru") return ru_offline_status_authentication(inputs)
	if (locale === "es") return es_offline_status_authentication(inputs)
	if (locale === "zh-CN") return zh_cn2_offline_status_authentication(inputs)
	if (locale === "ja") return ja_offline_status_authentication(inputs)
	if (locale === "hi") return hi_offline_status_authentication(inputs)
	if (locale === "pt-PT") return pt_pt2_offline_status_authentication(inputs)
	return en_offline_status_authentication(inputs)
});